import { Box } from '@warp-ds/react';
import IconCheck24 from '@warp-ds/icons/react/check-24';
import { SanitizedText } from '../index.js';

export type BannerType = {
    title: string;
    text: string;
};

const Banner = ({ banner }: { banner: BannerType }) => {
    const { title, text } = banner;
    return (
        <Box info className="mt-32 mb-24 flex space-x-16">
            <div className="shrink-0">
                <IconCheck24 className="s-bg-primary s-text-inverted rounded-full p-2" />
            </div>
            <div>
                <p className="font-bold">{title}</p>
                <SanitizedText text={text} />
            </div>
        </Box>
    );
};

export default Banner;
